module.exports = __webpack_public_path__ + "static/media/ThumbnailStill03.8b05d644.png";